import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import Configurer from "../../components/Configurer";

import DataGrid from "../../components/DataGrid";

import AdminModule from "../../components/boxes/AdminModule";
import { adminPages } from "../../variables/adminPages";
import { checkPermission, checkTranslation, translate } from "../../utils/useful";
import AdminWidgetsPage from "./AdminWidgetsPage";
import { siteConfig } from "../../variables/config";


class AdminDashboard extends React.Component {


    state = {
        modules: []
    }

    render() {
        // console.log('bef modules', this.props.modules)
        let modules = this.props.modules
        let newModule = []
        // console.log('modulesfirst',modules)
        // if (!this.props.home) {
        modules.map((item) => {
            if (!item.hidePage && (checkPermission('admin.' + item.key) ||checkPermission('settings.' + item.key) )|| item.defaultAccess) {
                newModule.push(item)
            }
        })
        // modules = modules.filter(m => { return m.hidePage != true })
        // }
        // console.log('after modules', modules)
        return (

            <Configurer
                settingsInfo={{ showFooter: true, showTabBar: true, showHeader: true, headerTitle: checkTranslation(this.props.title), button: {} }}
                title={checkTranslation(this.props.title)}
                description={this.props.description}
                className=""
            >

                <div className="row m-0" >

                    <div className="col-12 p-0 p-md-4">

                        <div className=" mb-4 px-3 px-md-0 mt-3 mt-md-0">
                            <p className="text-ultra-big " style={{ fontWeight: '500', color: '#222' }}>{checkTranslation(this.props.title)}</p>
                            <p className="text-small mt-1" style={{ color: '#456' }}>{checkTranslation(this.props.description)}</p>
                        </div>
                        
                        <div className="w-100 flexcc" style={{ backgroundColor: '' }}>

                            {/* {newModule.map((prop, index) => {
                                return (
                                    <button className="flex-1 w-100" style={{boxShadow: 'rgba(0, 0, 0, 0.125) 0px 0px 15px'}}>
                                        <div className=" px-2 pt-2 pb-3 flexcc w-100" onClick={() => { this.props.addNewWindow(prop?.window); this.props.toggle() }}>
                                            <img className="mt-1" src={prop?.image} height={40} />
                                            <div className="mld-3 w-100">
                                                <div className="flexcb w-100">
                                                    <p className="text-semibold text-normal ">{checkTranslation(prop.title)}</p>
                                                    {prop?.notif && (
                                                        <div className="portal-notification flexcc ">{prop?.notif}</div>
                                                    )}
                                                </div>
                                                <p className="text-smallest mt-0" style={{ textAlign: 'start' }}>{checkTranslation(prop?.description)}</p>
                                            </div>

                                        </div>
                                    </button>
                                )
                            })} */}
                        </div>
                        <DataGrid permissions={this.props.permissions} applet={this.props.applet} permissionBaseKey={this.props.permissionBaseKey} isLoading={this.state.isLoading} data={newModule} component={AdminModule} col="col-12 col-sm-6 col-md-6 col-lg-3 p-0 p-md-3" settings={{ route: this.props.baseUrl.join('/') }} />
                        
                        {/* Widgets for branch - after modules */}
                        {siteConfig.showAdminWidgets && siteConfig.showAdminWidgetsBranch && this.props.applet && (
                            <div className="w-100 mb-4 px-3 px-md-0 mt-4">
                                <AdminWidgetsPage 
                                    widget={null} 
                                    pages={this.props.pages || []} 
                                    stage={0} 
                                    user={this.props.user} 
                                    modules={[]} 
                                    stageName={''} 
                                    changePage={this.props.changePage} 
                                    title={translate("Branch Reports")} 
                                    description={translate("Branch-specific Reports")} 
                                    route={"admin"}
                                    variables={{ applet: this.props.applet?._id || this.props.applet }}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </Configurer>
        )
    }


}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AdminDashboard);
